import { fossaAnalysisViewType } from '../OrganizationPortal/hooks/useViewType';

export const organizationPortalRoute = (slug: string, options: { isPublic: boolean }) => `/p/${slug}/${options.isPublic ? 'public' : 'private'}`;

export const latestReleaseRoute = (slug: string, releaseGroupId: number) =>
  `/p/${slug}/release/${releaseGroupId}/latest`;

export const releaseGroupReleaseRoute = (slug: string, releaseGroupId: number, releaseId: number) =>
  `/p/${slug}/release/${releaseGroupId}/${releaseId}`;

export const releaseGroupDependenciesRoute = (slug: string, releaseGroupId: number, releaseId: number) =>
  `/p/${slug}/release/${releaseGroupId}/${releaseId}/${fossaAnalysisViewType}`;

export const releaseReportRoute = (slug: string, releaseId: number) =>
  `/api/organization-portals/${slug}/releases/${releaseId}/report`;

export const releaseDependenciesRoute = (slug: string, releaseId: number) =>
  `/api/organization-portals/${slug}/releases/${releaseId}/dependencies`;

export const tokenAuthenticationRoute = (slug: string) => `/api/organization-portals/${slug}/token-authentication`;
